module.exports = __webpack_public_path__ + "static/img/3101_phase_function_Paper_Points.bd197f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3101_phase_function_Paper_Points.png
// module id = /OFX
// module chunks = 0